var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counties && _vm.coverage)?_vm._m(0):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('county-map',{attrs:{"counties":_vm.colored,"view-box":_vm.counties.viewBox,"transform":_vm.counties.transform}})
}]

export { render, staticRenderFns }